import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type MappingDiscoveryResponse as SchemaMappingDiscoveryResponse } from '../schemas/MappingDiscoveryResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetMappingDiscoveryResultContentType = '' as const;
export type GetMappingDiscoveryResultRequest = void;
export type GetMappingDiscoveryResultResponses = LinkCommonErrorResponses & {
    /**
     * @description Current discovery status and last successful result for this source
     */
    '200': {
        'application/json': SchemaMappingDiscoveryResponse;
    };
};
export type GetMappingDiscoveryResultResponseSuccess = GetMappingDiscoveryResultResponses['200']['application/json'];
export type GetMappingDiscoveryResultSearchParams = undefined;
export type GetMappingDiscoveryResultPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const GetMappingDiscoveryResultUrl = '/integrations/mapping_discovery/{integration_type}' as const;
export const GetMappingDiscoveryResultMethod = 'GET' as const;
export const getGetMappingDiscoveryResultUrl = (params: GetMappingDiscoveryResultPathParameters) =>
    GetMappingDiscoveryResultUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetMappingDiscoveryResultPathParameters) =>
        String(params[param])
    );
